<template>
	<!-- 权限配置 -->
	<el-drawer :visible.sync="menuAccessshow" title="权限配置" :size="600" :wrapper-closable="false" :modal="false" :destroy-on-close="true" class="margin_top_40" @click="closeDialog">
		<div class="mas_01">
			<!-- <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="mini" :close-on-click-modal="false">
			</el-input> -->
			<el-tree
				ref="tree"
				class="filter-tree"
				:default-expand-all="false"
				:data="RoleRight"
				:props="RoleRightProps"
				node-key="keyId"
				show-checkbox
				:filter-node-method="filterNode"
				:default-expanded-keys="treeExpandData"
				:default-checked-keys="checkedKeyArray"
				@check="checkMenu"
			></el-tree>
		</div>

		<div class="drawer-footer" style="z-index: 1000">
			<el-button size="small" :loading="loading" class="title" @click="menuPermSave">保存</el-button>
			<el-button size="small" @click="closeDialog">取消</el-button>
		</div>
	</el-drawer>
</template>

<script>
import { GetOnLineMenuTreeList, GetRoleLinkMenu2List, SaveRoleLinkMenu2 } from "../../../api/menuApi.js";
export default {
	data() {
		return {
			menuAccessshow: false, //菜单树图显示与隐藏
			loading: false,
			filterText: "",
			RoleRight: [],
			RoleRightProps: {
				children: "subList",
				label: "menuName"
			},
			checkedKeyArray: [],
			treeExpandData: [],
			menuOperationTemp: []
		};
	},
	computed: {},
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		}
	},
	methods: {
		filterNode(value, data) {
			if (!value) return true;
			return data.menuName.indexOf(value) !== -1;
		},
		// 菜单数据
		menuAccess(row) {
			this.menuOperationTemp = [];
			this.checkedKeyArray = [];
			this.treeExpandData = [];
			this.menuAccessshow = true;
			this.saveroleId = row.keyId;
			let param = {};
			GetOnLineMenuTreeList(param)
				.then((res) => {
					if (res.code == 1) {
						let tempA = res.data;
						tempA.forEach((item) => {
							if (item.subList.length > 0) {
								item.subList.forEach((sub) => {
									if (sub.btnList && sub.btnList.length > 0) {
										sub.subList = sub.btnList.map((btn) => {
											let obj = {
												menuName: btn.menuName,
												keyId: sub.keyId + "_" + btn.keyId,
												type: 2,
												keyIdA: btn.keyId,
												parentKeyId: sub.keyId
											};
											return obj;
										});
									}
								});
							}
						});
						this.RoleRight = res.data;
						this.GetRoleLinkModuleList(row.keyId);
					} else {
						this.$message({
							type: "info",
							message: res.data.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取权限失败，请稍后再试！");
				});
		},

		//获取关联的菜单
		GetRoleLinkModuleList(id) {
			let param = {
				keyId: id
			};
			GetRoleLinkMenu2List(param)
				.then((res) => {
					if (res.code === 1) {
						this.checkedKeyArray = res.data.filter((item) => item.length > 40);
						this.treeExpandData = res.data;
					} else {
						this.$message.info(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("加载失败，请稍后再试！");
				});
		},

		// 选择菜单节点时候的钩子
		checkMenu(obj, val) {
			this.menuOperationTemp = [];
			let tempA = val.checkedNodes;
			let tempH = val.halfCheckedNodes;
			if (tempA) {
				tempA.forEach((item) => {
					let tempB = {};
					tempB.halfType = 1;
					tempB.parentKeyId = "";
					tempB.type = 1;
					if (item.parentKeyId) {
						tempB.parentKeyId = item.parentKeyId;
					}

					if (item.type === 2) {
						tempB.type = 2;
						tempB.keyId = item.keyIdA;
					} else {
						tempB.keyId = item.keyId;
					}
					this.menuOperationTemp.push(tempB);
				});
			}
			if (tempH) {
				tempH.forEach((item) => {
					let tempF = {};
					tempF.parentKeyId = "";
					tempF.type = 1;
					tempF.halfType = 2;
					if (item.parentKeyId) {
						tempF.parentKeyId = item.parentKeyId;
					}
					tempF.keyId = item.keyId;
					// if (item.btnList && item.btnList.length > 0) {
					// 	tempF.halfType = 2
					// }
					this.menuOperationTemp.push(tempF);
				});
			}
		},

		// 角色权限配置-保存
		menuPermSave() {
			if (this.menuOperationTemp.length > 0) {
				let parm = {
					keyId: this.saveroleId,
					dtls: this.menuOperationTemp
				};
				SaveRoleLinkMenu2(parm)
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "权限保存成功"
							});
							this.menuAccessshow = false;
							this.checkedKeyArray = [];
							this.treeExpandData = [];
							this.$parent.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.$message.error("加载失败，请稍后再试！");
					});
			} else {
				this.$message.warning("请操作后保存！");
			}
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.menuAccessshow = false;
			this.checkedKeyArray = [];
			this.treeExpandData = [];
			this.menuOperationTemp = [];
		}
	},
	created() {},
	mounted() {},
	components: {}
};
</script>
<style scoped>
.mas_01 {
	margin-bottom: 60px;
}
</style>
